import { Theme } from '@mui/material/styles'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const UserDetailsStyles: moduleStyleType = {
    formFieldContainer: (theme: Theme) => ({
        gap: theme.spacing(1),
    }),
    delegateLabel: {
        display: 'inline-flex',
        marginBottom: 1,
    },
    buttonsContainer: {
        display: 'flex',
    },
    cancelButton: {
        marginRight: 1,
    },
}

export const AccountListForUserStyles: moduleStyleType = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto',
        maxHeight: 'calc(100vh - 280px)',
    },
}
